import React, { useState, useEffect } from 'react'
import { Panel, Row, form, Col, Input, SelectPicker, Icon, Button, DatePicker } from 'rsuite'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../utils/ValidatorUtils'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import moment from 'moment'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'

export default function MiniProjectInfoListDurableArticles({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  ControlLabel,
  control,
  setValue,
  clearErrors,
  getValues,
  onSearch = () => {},
  ...props
}) {
  const [formSchema, setFormSchema] = useState(_schema)

  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()

  return (
    <>
      <Panel bordered header={'ค้นหา'}>
        <Row>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.projectCode.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <Input
              name={formSchema.projectCode.name}
              defaultValue={formSchema.projectCode.value}
              inputRef={register(isValidators(formSchema.projectCode.validators))}
              placeholder={'กรุณากรอก' + formSchema.projectCode.label}
            />
          </Col>
          {/* </Row>
        <Row style={{ marginTop: 10 }}> */}
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.projectName.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <Input
              name={formSchema.projectName.name}
              defaultValue={formSchema.projectName.value}
              inputRef={register(isValidators(formSchema.projectName.validators))}
              placeholder={'กรุณากรอก' + formSchema.projectName.label}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.startDate.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <Controller
              key={formSchema.startDate.name}
              name={formSchema.startDate.name}
              control={control}
              rules={isValidators(formSchema.startDate.validators)}
              defaultValue={startDate}
              disabledDate={(date) => endDate && moment(endDate).isAfter(date, new Date())}
              render={(props) => {
                return (
                  <DatePickerCustom 
                    {...props}
                    onChange={(value) => {
                      props.onChange(value)
                      setStartDate(value)
                      // onChangeReportDate(value)
                    }}
                  />
                  // <DatePicker
                  //   format={DATE_PICKER_FORMAT}
                  //   locale={LOCAL_DAY_TH}
                  //   block
                  //   value={props.value}
                  //   onChange={(value) => {
                  //     props.onChange(value)
                  //     setStartDate(value)
                  //     // onChangeReportDate(value)
                  //   }}
                  // />
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.endDate.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <Controller
              key={formSchema.endDate.name}
              name={formSchema.endDate.name}
              control={control}
              rules={isValidators(formSchema.endDate.validators)}
              defaultValue={endDate}
              disabledDate={(date) => startDate && moment(startDate).isBefore(date, new Date())}
              render={(props) => {
                return (
                  <DatePickerCustom 
                    {...props}
                    onChange={(value) => {
                      props.onChange(value)
                      setEndDate(value)
                      // onChangeReportDate(value)
                    }}
                  />
                  // <DatePicker
                  //   format={DATE_PICKER_FORMAT}
                  //   locale={LOCAL_DAY_TH}
                  //   block
                  //   value={props.value}
                  //   onChange={(value) => {
                  //     props.onChange(value)
                  //     setEndDate(value)
                  //     // onChangeReportDate(value)
                  //   }}
                  // />
                )
              }}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.assetStatus.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <Controller
              name={formSchema.assetStatus.name}
              control={control}
              defaultValue={formSchema.assetStatus.value}
              rules={isValidators(formSchema?.assetStatus?.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    searchable={false}
                    data={formSchema.assetStatus.options}
                    value={props.value}
                    block
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={20} md={20} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <SearchButton
              disabled={false}
              onClick={() => {
                let request = {
                  projectCode: getValues(formSchema.projectCode.name),
                  projectName: getValues(formSchema.projectName.name),
                  startDate: getValues(formSchema.startDate.name)
                    ? moment(getValues(formSchema.startDate.name)).format('YYYY-MM-DD')
                    : '',
                  endDate: getValues(formSchema.endDate.name)
                    ? moment(getValues(formSchema.endDate.name)).format('YYYY-MM-DD')
                    : '',
                  assetStatus: getValues(formSchema.assetStatus.name),
                }
                onSearch(request)
              }}
              style={{ marginTop: 0, marginLeft: 10 }}
            >
              ค้นหา
            </SearchButton>
            <CancelButton
              onClick={() => {
                setValue(formSchema.projectCode.name, '')
                setValue(formSchema.projectName.name, '')
                setValue(formSchema.startDate.name, '')
                setValue(formSchema.endDate.name, '')
                setValue(formSchema.assetStatus.name, '')

                setStartDate()
                setEndDate()

                onSearch({})
              }}
              style={{ marginTop: 0, marginLeft: 10 }}
            >
              ยกเลิก
            </CancelButton>
          </Col>
        </Row>
      </Panel>
    </>
  )
}
